import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  AbstractServerInteractionService,
  combineHeadersOptions,
  commonErrorHandlingDisabled
} from '../abstract/abstract.server.interaction.service';
import { Observable } from 'rxjs';
import { II9Info, I9VerificationMethodEnum, I9StatusesEnum } from './interfaces';
import { AppService } from '../../../../app.service';

@Injectable()
export class I9FormService extends AbstractServerInteractionService {
  protected get url(): {
    info: string,
    reinitiate: string,
    verificationMethod: string,
    updateStatus: string,
  } {
    return this.appService.getApiUrls().i9;
  }

  constructor(protected appService: AppService,
              protected http: HttpClient) {
    super();
  }

  public fetchInfo(): Observable<II9Info | any> {
    return this.http.get(this.url.info);
  }

  public reinitiate() {
    return this.http.post(this.url.reinitiate, null);
  }

  public saveVerificationMethod(method: I9VerificationMethodEnum) {
    return this.http.post(this.url.verificationMethod, { VerificationMethod: method });
  }

  public updateStatus(status: I9StatusesEnum) {
    return this.http.post(
      this.url.updateStatus,
      { StatusId: status },
      { headers: combineHeadersOptions(commonErrorHandlingDisabled) });
  }
}
